<a routerLink="/posts" class="icon__home">
  <span class="barlow-font">  {{ "posts.actions.home.button" | translate }}</span>
</a>
